import React from "react";

const PrintIcon = () => {
  return (
    <svg viewBox="0 0 500.19 485.72">
      <path
        d="M59.89,376.38v-125q0-23.75,17-40.74t40.73-17h19.24V93.1A28.73,28.73,0,0,1,165.7,64.24h202q12,0,26.45,6T417,84.68l45.69,45.69q8.42,8.41,14.43,22.85t6,26.45v14h19.24q23.75,0,40.73,17t17,40.74v125a9.75,9.75,0,0,1-9.62,9.62H483.13V521.1A28.73,28.73,0,0,1,454.28,550H165.7a28.73,28.73,0,0,1-28.85-28.86V386H69.51a9.75,9.75,0,0,1-9.62-9.62ZM175.32,232.1H444.66V179.67h-48.1a28.73,28.73,0,0,1-28.85-28.86V102.72H175.32Zm0,279.38H444.66v-164H175.32ZM488.85,237.81a18.87,18.87,0,1,0,13.52-5.71A18.5,18.5,0,0,0,488.85,237.81Z"
        transform="translate(-59.89 -64.24)"
      />
      <rect x="146.71" y="331.06" width="173.44" height="22.46" rx="6.99" />
      <rect x="146.71" y="379.66" width="206.78" height="22.46" rx="7.64" />
    </svg>
  );
};

export default PrintIcon;
